import { render, staticRenderFns } from "./right_12.vue?vue&type=template&id=db1c1e8c&scoped=true&"
import script from "./right_12.vue?vue&type=script&lang=js&"
export * from "./right_12.vue?vue&type=script&lang=js&"
import style0 from "./right_12.vue?vue&type=style&index=0&id=db1c1e8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db1c1e8c",
  null
  
)

export default component.exports